export default __webpack_public_path__ + "static/media/img-2.c6ba448c.jpg";